import React from 'react';
import PropTypes from 'prop-types';

import UserBookshelvesList from './UserBookshelvesList';
import styles from './style.scss';


const BookDetailUserBookshelves = ({ bookshelves, userId }) => (
  <div className="billetContainerNoOverflow">
    <div className={styles.bookshelfTitle}>
      <h2>Мои полки с этой книгой</h2>
    </div>
    <UserBookshelvesList
      bookshelves={bookshelves}
      userId={userId} />
  </div>
);

BookDetailUserBookshelves.propTypes = {
  bookshelves: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    })
  ).isRequired,
};

export default BookDetailUserBookshelves;
